import Button from "@material-ui/core/Button";
import DynamicForm from "Component/DynamicForm";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import ProfilePicture from "Component/Thumbnail/ProfilePicture";
import { withSnackbar } from "notistack";
import React from "react";
import { instance } from "Actions/AxiosInstance";
import { connect } from "react-redux";
import { getFormattedImageLink } from "Utils";
import moment from "moment";

const audiencetype = [
  {
    displayvalue: 1,
    displayname: "All",
  },
  {
    displayvalue: 2,
    displayname: "Self (Private note)",
  },
];

export class Notes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      moreOptions: false,
      moreOptions_anchorEl: null,
      imagepath: "",
      audienceId: 1,
      isprivate: false,
      note: "",
      notedata: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.addNote = this.addNote.bind(this);
  }

  componentDidMount() {
    this.getNote();
  }

  getNote() {
    const data = {
      candidateid: this.props.candidateid,
      ishistory: true,
    };
    const URL = `recruit/getcandidatenote`;
    instance
      .post(URL, data)
      .then((result) => {
        this.setState({
          notedata: result.data.result,
        });
        // this.props.enqueueSnackbar("Saved successfully", { variant: 'success' });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  handleChange(key, value) {
    if (key == "audienceId") {
      this.setState({ [key]: value, isprivate: value == 1 ? false : true });
    }
    this.setState({ [key]: value });
  }

  addNote() {
    const data = {
      candidateid: this.props.candidateid,
      pipelinestageid: this.props.pipelinestageid,
      note: this.state.note,
      isprivate: this.state.isprivate,
    };
    this.setState({
      isDisableSaveButton: true,
    });
    const URL = `recruit/insertupdatecandidatenote`;
    instance
      .post(URL, data)
      .then((result) => {
        this.getNote();
        this.setState({
          audienceId: 1,
          isprivate: false,
          note: "",
          isDisableSaveButton: false,
        });
        this.props.enqueueSnackbar("Note added successfully", {
          variant: "success",
        });
        this.setState({
          isDisableSaveButton: false,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
        this.setState({
          isDisableSaveButton: false,
        });
      });
  }

  render() {
    const { notedata } = this.state;

    return (
      <div>
        <div className="floatleft margin-right-16">
          <ProfilePicture
            src={getFormattedImageLink(this.state.imagepath)}
            height="40"
          />
        </div>
        <div className="floatleft">
          <div
            style={{ width: 364 }}
            className={
              this.state.audienceId == 1
                ? "other-note-text"
                : "private-note-text"
            }
          >
            <DynamicForm
              fields={textareainputconverter({
                value: this.state.note,
                label: "",
                placeholder: "Notes",
                disabled: this.props.candidateempid ? true : false,
              })}
              onChange={(e) => this.handleChange("note", e)}
            />
          </div>
          <div>
            <p className="small-dark-secondary inline-block margin-right-8">
              Make this note visible to
            </p>
            <div className="inline-block" style={{ width: 194 }}>
              <DynamicForm
                fields={selectinputconverter({
                  value: this.state.audienceId,
                  placeholder: "All",
                  label: "",
                  options: audiencetype,
                  disabled: this.props.candidateempid ? true : false,
                })}
                onChange={(selectedid) => {
                  this.handleChange("audienceId", selectedid);
                }}
              />
            </div>
          </div>

          <Button
            className={
              this.props.candidateempid
                ? "btn btn-primary-md-grey margin-bottom-16"
                : "btn btn-primary-md-blue margin-bottom-16"
            }
            variant="contained"
            onClick={this.addNote}
            disabled={this.state.isDisableSaveButton || this.props.candidateempid ? true : false}
          >
            Add note
          </Button>
        </div>

        <div className="dashed-divider1 position-rel text-center clear-float">
          <span
            style={{
              background: "#fff",
              position: "relative",
              top: -14,
              padding: "0px 24px",
            }}
            className="extra-small-dark-secondary"
          >
            Notes history
          </span>
        </div>
        {notedata &&
          notedata.map((x) => (
            <div style={{ display: "flex", marginBottom: 16 }}>
              <div className="margin-right-16">
                <ProfilePicture
                  src={getFormattedImageLink(this.state.imagepath)}
                  height="40"
                />
              </div>
              <div>
                <div
                  className="rounded-rectangle-div"
                  style={
                    x.isprivate
                      ? { background: "#fef1d9" }
                      : { background: "#fff" }
                  }
                >
                  <p className="small-dark-secondary">{x.note}</p>
                </div>
                {x.isprivate ? (
                  <p className="extra-small-dark-secondary margin-top-8 inline-block">
                    Private note on {moment(x.updateddate).format("YYYY-MM-DD")}{" "}
                    &nbsp;• {x.stagename}
                  </p>
                ) : (
                  <p className="extra-small-dark-secondary margin-top-8 inline-block">
                    {x.fullname} on {moment(x.updateddate).format("YYYY-MM-DD")}{" "}
                    &nbsp;• {x.stagename}
                  </p>
                )}
              </div>
            </div>
          ))}
      </div>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withSnackbar(Notes));
